import { tableColumnsStorageKey, } from '@wit-support/ui';
/** Ключ хранения настроек таблицы: `ui.table.payback.<table>.v1`. */
export function paybackColumnsKey(table) {
    return tableColumnsStorageKey('payback', table);
}
/** Старый ключ (до кита): массив id выбранных дополнительных колонок. */
export function legacyColumnsKey(table) {
    return `payback.cols.${table}.v1`;
}
/**
 * Старый формат → состояние кита. Старое меню знало только дополнительные
 * колонки (`defaultVisible: false`): выбранные становятся видимыми, остальные
 * колонки — как по умолчанию. Порядок — порядок описания (старое меню порядок
 * не меняло). Не массив или битый JSON — `null` (переносить нечего).
 */
export function migrateLegacyColumns(raw, defs) {
    let data;
    try {
        data = JSON.parse(raw);
    }
    catch {
        return null;
    }
    if (!Array.isArray(data))
        return null;
    const chosen = new Set(data.filter((x) => typeof x === 'string'));
    return defs.map((d) => ({
        id: d.id,
        visible: d.hideable === false || (d.defaultVisible ?? true) || chosen.has(d.id),
        pin: d.pinnable === false ? null : (d.defaultPin ?? null),
    }));
}
/** Опция `legacy` для `useTableColumns`: перенос `payback.cols.<table>.v1`. */
export function legacyColumns(table, defs) {
    return { key: legacyColumnsKey(table), migrate: (raw) => migrateLegacyColumns(raw, defs) };
}
/**
 * Сортировка для меню «Колонки»: отметка ↑/↓ у колонки, по которой сортируют
 * (и когда её скрыли). Служебные ключи без колонки — без отметки.
 */
export function menuSort(sort, defs) {
    return defs.some((d) => d.id === sort.key) ? sort : null;
}
//# sourceMappingURL=table-columns.js.map